import React,{Component} from 'react'
import moment from 'moment'
import firebase from '../helper/firebase'

import _ from 'lodash'

import {Link} from 'react-router-dom'

import UnauthorizedText from './UnauthorizedText'
import JobCardStatusIndicatorChip from './JobCardStatusIndicatorChip'
import SkeletonCard from './SkeletonCard'

import {
  Avatar,
  Button,
  Card,
  Divider,
  ListItemText,
  ListItem,
  List,
  // Typography,
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

// import SectionTitle from './SectionTitle'

// import {
  // Accent,
  // Primary,
  // Purple,
  // Green,
  // LightGray,
// } from '../helper/consts'

// const colors = [Primary,Accent,Purple,Green,LightGray]

const style = {
  topJobsCard:{
    justifyContent: 'center',
    alignItems: 'center',
    // maxWidth: '540px',
    maxWidth: '100%',
  },
  listItem:{
    width: '100%',
    // max-width: '780px',
    minWidth: '300px',
    margin: '11px 0',
    overflow: 'visible',
    position: 'relative',
    border: '1px solid rgba(0,0,0,0.07)',
    boxShadow: '0 1px 5px rgba(0,0,0,0.05)',
  },
  noJobs:{
    width: '100%',
    minHeight: '50px',
    margin: '0 auto',
    maxWidth:'1080px',
  },
  viewMore:{
    width:'100%',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  }
}


export default class DashboardApplications extends Component{
  constructor(){
    super();

    this.state = {
      loading:true,
      jobs:[],
    }
  }

  componentDidMount(){
    const {applications} = this.props;
    const monthAgo = moment().subtract(4, 'weeks').valueOf();
    const archivedApplications = Object.keys(applications)
    .map(jid=>applications[jid])
    .filter(application=>application.timestamp >= monthAgo)
    .filter(application=>!!application.archived)
    .splice(0,5)
    const activeApplications = Object.keys(applications)
    .map(jid=>applications[jid])
    .filter(application=>application.timestamp >= monthAgo)
    .filter(application=>!application.archived)
    .splice(0,5)
    const filteredApplications = archivedApplications.concat(activeApplications);
    if(_.isEmpty(filteredApplications)){
      this.setState({loading:false,jobs:[]});
      return;
    }
    else{
      let promises = filteredApplications
      .map(application=>{
        const jid = application.jid
        return firebase.firestore().collection('jobs').doc(jid).get().then(job=>{
          let {jobs} = this.state;
          jobs.push(job.data())
          this.setState({
            jobs,
            loading:false,
          })
        })
      })
      Promise.all(promises)
      .catch(error=>{
        console.log(error);
      })
    }
  }

  renderApplications=()=>{
    let html = []
    const jobs = this.state.jobs;
    const applications = this.props.applications || {};
    const filteredJids = Object.keys(applications).map(jid=>applications[jid]).filter(application=>!!application.archived===!!this.props.archives).map(application=>application.jid)
    jobs.forEach((job,i)=>{
      if(filteredJids.indexOf(job.jid)!==-1){
        let item = (
          <ListItem key={job.jid} dense >
            <Avatar
              aria-label={job.company}
              src={job.logo && job.logo.downloadURLs && job.logo.downloadURLs[0]}
            >
              {(job.logo && job.logo.downloadURLs && job.logo.downloadURLs[0]) ? null : job.company[0]}
            </Avatar>
            <ListItemText primary={<Link to={`/Offer/${applications[job.jid].oid}`}>{job.title} @ {job.company}</Link>} />
            <JobCardStatusIndicatorChip job={job} />
          </ListItem>
        )
        html.push(item)
        html.push(<Divider key={`${job.jid}_divider`} light />)
      }
      i===(jobs.length-1) && html.push(<ListItem key={'viewAllApplications'} dense ><Link style={style.viewMore} to={'/Applications'}><Button>View All</Button></Link></ListItem>)
    })
    if(html.length===1){
      html.unshift(<UnauthorizedText key="no_applications_dashboard" subText={!!this.props.archives ? 'No Archived Applications' : 'No Active Applications'} />)
    }
    return html;
  }

  render(){
    return(
      this.state.loading ?
        <SkeletonCard content={true} />
      :
        this.state.jobs.length===0 ?
          <Card className='card' style={style.noJobs} >
            <UnauthorizedText subText='No Recent Applications' />
          </Card>
        :
          <Fade in={true}>
            <div className="dashboardCard" style={style.topJobsCard}>
              <Card style={style.listItem}>
                <List>
                  {this.renderApplications()}
              </List>
              </Card>
            </div>
          </Fade>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DashboardApplications.js